module.exports = __webpack_public_path__ + "static/media/stop.ca37e43c.svg";